import { colors } from "@/lib/styles";
import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import Button from "@/components/universal/Button/Button";
import Title from "../universal/Text/Title";
import Description from "../universal/Text/Description";
import useOwner from "@/hooks/useOwner";
import { ownerPath } from "@/lib/path";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

const Error404 = () => {
  const router = useRouter();
  const owner = useOwner();

  const redirect = useCallback(() => {
    if (owner) router.push(ownerPath(owner, ""));
    else router.push("/");
  }, [router, owner]);

  useEffect(() => {
    setTimeout(() => {
      redirect();
    }, 3000);
  }, []);

  return (
    <>
      <Wrapper>
        <Title>Page Not Found</Title>
        <Description>
          {"We couldn't find the page you were looking for. Sorry about that!"}
        </Description>
        <Button
          style={{ marginTop: 20, fontSize: 21 }}
          color={colors.gray}
          backgroundColor={colors.nearWhite}
        >
          Redirecting...
        </Button>
      </Wrapper>
    </>
  );
};
export default Error404;
